import classNames from "classnames";
import React, { memo } from "react";

function calcBarPercentages(...values) {
  const total = values.reduce((p, v) => p + v, 0);

  if (total > 0)
    return values.map(v => `${100.0 * v / total}%`);
  else
    return values.map(v => `${100.0 / values.length}%`);
}

function arrayPropEqual(oldValue, newValue) {
  if (oldValue?.length !== newValue?.length) {
    return false;
  }
  for(var i=0; i<oldValue.length; i++)
    if (oldValue[i] !== newValue[i])
        return false;
  return true;
}

const Bar = memo(({ thickness, values, colors }) => {
  const factors = calcBarPercentages(...values);

  return (
    <div className='bar__bar bar__notchedBar' style={thickness && {"--bar-height": thickness}}>
      {
        factors.map((factor, index) => <div key={index} style={{flexBasis: factor, backgroundColor: colors[index] }} />)
      }
    </div>
  )
}, (oldProps, newProps) => {
  return oldProps.thickness === newProps.thickness && arrayPropEqual(oldProps.values, newProps.values) && arrayPropEqual(oldProps.colors, newProps.colors);
});

const Bar1v1 = memo(({ name, player1, player2, leftColor, rightColor }) => {

  const factors = calcBarPercentages(player1, player2);

  return (
    <div className='bar'>
      <h1 className='bar__header'>{name}</h1>
      <div className={classNames("bar__bar bar__notchedBar", name)}>
        <div className="bar__labels">
          <h1 className="text-white">{parseInt(player1)}</h1>
          <h1 className="text-white text-right">{parseInt(player2)}</h1>
        </div>
        <div className={`bar__leftPlayer`} style={{flexBasis: factors[0], backgroundColor: leftColor }}></div>
        <div className={`bar__rightPlayer`} style={{flexBasis: factors[1], backgroundColor: rightColor }}></div>
      </div>
    </div>
  )
} );

export { Bar, Bar1v1 };
